document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#filters-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const params = new URLSearchParams(new FormData(form)).toString();
    const newUrl = `${window.location.pathname}?${params}`;
    window.location.href = newUrl;
  });
});
